export default __webpack_public_path__ + "media/images/images/portfolio/width-1200/portfolio-3-ccd6ce5e1281ee2d5ae67244604b842e.jpg";